import type { ComponentProps } from "react";
import { Button as ButtonBase, ButtonText } from "@ptsd/uikit";
import { Separator as SeparatorBase, styled, XStack } from "tamagui";
import type { XStackProps } from "tamagui";

const Body: React.FC<
  Omit<XStackProps, "position"> & {
    position: { x?: number; y: number };
  }
> = ({ children, position, ...rest }) => {
  return (
    <XStack
      position="absolute"
      zIndex={999}
      height={"$7"}
      borderRadius={"$5"}
      borderColor={"$gray-primary-900"}
      borderWidth={"$0.2"}
      backgroundColor={"white"}
      gap={"$2"}
      paddingHorizontal={"$3"}
      paddingVertical={"$1.5"}
      {...position}
      {...rest}
    >
      {children}
    </XStack>
  );
};

type ButtonProps = ComponentProps<typeof ButtonBase>;

const Button: React.FC<ButtonProps> = ({
  children,
  color = "$gray-primary-900",
  ...rest
}) => {
  return (
    <ButtonBase
      padding={0}
      height={"auto"}
      variant="transparent"
      size="md"
      hoverStyle={{
        backgroundColor: "transparent",
      }}
      {...rest}
    >
      <ButtonText color={color} font={"md"}>
        {children}
      </ButtonText>
    </ButtonBase>
  );
};

const Separator = styled(SeparatorBase, {
  borderColor: "$gray-secondary-400",
  borderRightWidth: "$0.2",
  height: "$3",
  vertical: true,
});

export const RowFloatingPanel = {
  Body,
  Button,
  Separator,
};
